import React from 'react'
import Container from '@material-ui/core/Container';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import imgHero from '../../assets/imghero.jpg';
import imgHero2 from '../../assets/imghero2.jpg';
import galeria1 from '../../assets/galeria1.jpg';
import galeria2 from '../../assets/galeria2.jpg';
import galeria3 from '../../assets/galeria3.jpg';
import galeria5 from '../../assets/galeria5.jpg';
import galeria6 from '../../assets/galeria6.jpg';
import galeria7 from '../../assets/galeria7.jpg';



const Section3 = () => {
  return (
    <div id='proyecto' className='section noPadBot'>
        <Container className='relative flex flexCol relative'>
         
              <Swiper
                spaceBetween={30}
                grabCursor={true}
                pagination={{
                  clickable: true,
                }}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                modules={[Autoplay, Pagination]}
                className="galeriaSwiper shadow"
              >
                <SwiperSlide>
                  <img src={galeria1} alt="Glaeria 1" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src={imgHero2} alt="Interior 1" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src={imgHero} alt="Glaeria Hero" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src={galeria2} alt="Glaeria 2" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src={galeria3} alt="Glaeria 3" />
                </SwiperSlide>
               
                <SwiperSlide>
                  <img src={galeria5} alt="Glaeria 5" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src={galeria6} alt="Glaeria 6" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src={galeria7} alt="Glaeria 7" />
                </SwiperSlide>
              </Swiper>
              <div className="floatTitle shadow">
                <h2>Proyecto</h2>
                <p>Proyecto multifamiliar de 6 deptos tipo Loft de 50 m2 cada uno con cocheras y bauleras individuales más espacios comunes.</p>
              </div>
        </Container>
    </div>
  )
}

export default Section3